const formatAction = action => {
  switch (action) {
    case 'create':
      return 'Criação'
    case 'update':
      return 'Atualização'
    case 'destroy':
      return 'Remoção/Inativação'
    default:
      return 'Não identificada'
  }
}

export default formatAction
